import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useWebHaptics } from "web-haptics/react";
import useLocalStorage from "./useLocalStorage";

export default function useDrawHaptic(cardCount: number) {
    const { trigger } = useWebHaptics();
    const [hapticEnabled] = useLocalStorage<boolean>("LASTDOTCARDS.HAPTIC", true);

    return React.useCallback(() => {
        if(!hapticEnabled) {
            return;
        }

        const count = Math.min(cardCount, 8);
        const pulses = [];

        for(let i = 0; i < count; i++) {
            pulses.push({
                delay: i === 0 ? 0 : 60 - i * 5,
                duration: 40 + i * 20,
                intensity: Math.min(0.6 + i * 0.15, 1),
            });
        }

        trigger(pulses);
    }, [hapticEnabled, trigger, cardCount]);
}
